import React from 'react';
import { Typography, Box } from '@mui/material';
import { currentUser } from 'system/InfegyUser';
import AvatarMenu from './AvatarMenu';
import HelpMenu from './HelpMenu';
import { Link } from 'react-router-dom';

interface TopBarOptions {
  children?: React.ReactNode;
  title?: string;
  subTitle?: string;
  hideAvatar?: boolean;
  showLogo?: boolean;
}

export default function TopBar(props: TopBarOptions) {
  const user = currentUser();

  return (
  <Box sx={{ pb: 1, display:"grid", gridTemplateColumns: "auto 1fr auto"}}>
    <Box sx={{verticalAlign: "middle", display: "inline-block", padding: "2px 0 0 2px"}}>
      {props.showLogo &&
        <Link to="/">
          <img style={{ height: "3rem", width: "auto", marginLeft: "-8px" }} src="/img/Infegy_Logo_FullColor.svg" alt="Infegy Starscape logo" />
        </Link>
      }
    </Box>
    <Box>
      <Typography variant="h3" sx={{opacity:"0.7", paddingTop:"10px", textAlign:"center", fontWeight:"600"}}>
        {props.title}
      </Typography>
      <Typography variant="h5" sx={{opacity:"0.7", textAlign:"center", fontWeight:"normal"}}>
        {props.subTitle}
      </Typography>
    </Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {user && !props.hideAvatar &&
        <>
          <HelpMenu />
          <AvatarMenu />
        </>
      }
    </Box>
  </Box>
  );
}